import React from 'react';
import { useMediaBreakpoint } from '@americanexpress/consumer-travel-base';
import AbandonHotelMobile from './Mobile/AbandonHotelMobile';
import AbandonHotelDesktop from './Desktop/AbandonHotelDesktop';
import { useIsCenturionContext } from '../../context/isCenturionContext';
import { useAbandonCartData } from '../../hooks/useContextApiHook';
import { isValidHotelDisplayDate } from '../../utils/abandonCartUtils';
import { useFeatureFlagWithProperties } from '../../thunks/useFeatureFlagWithProperties';
import { ABANDON_CART_FF } from '../../constants/oneXpConstants';

const AbandonHotel = () => {
  const isDesktop = useMediaBreakpoint('lg-up');
  const hasDisplayAbandonHotel = useFeatureFlagWithProperties(ABANDON_CART_FF);
  const isCenturion = useIsCenturionContext();
  const { data: abandonCartData, error, isLoading } = useAbandonCartData();

  if (
    hasDisplayAbandonHotel
    && !isCenturion
    && !error
    && !isLoading
    && Object.keys(abandonCartData).length > 0
    && isValidHotelDisplayDate(abandonCartData?.tripStartDate)
  ) {
    return (
      <div id="abandonHotelBanner">
        {isDesktop ? <AbandonHotelDesktop /> : <AbandonHotelMobile />}
      </div>
    );
  }

  return null;
};

export default AbandonHotel;
